import { Dispatch, SetStateAction, useEffect, useState } from "react";
import * as framerMontion from "framer-motion";
import { Card } from "./components/Card";
import Header from "../Header/Header";
import { IHoursManagementGrid, IProject, IResponseGetBankHours } from "./models";

import "./index.scss";
import { ProjectHoursBalance, ProjectsNameMuntipleCard } from "./libs/ProjectsNameMutipleCard";
import Spinner from "../../../../components/Spinner";
import { ModalDebitHours } from "../ModalDebitHours";
import { getHoursManagement } from "../../service";
import useAuthData from "../../../../hook/useAppData";
import { useHistory } from "react-router-dom";
import BackCards from "../FilterROw/components/BackCards";
import Input from "../../../../components/Input";
import { FilterData } from "../../../../libs/FilterGeneric/filterGeneric";
import { AutoCompleteList } from "../../../../libs/autoCompleteList";

export default function ListHoursManagement() {
  const { token } = useAuthData();
  const { AnimatePresence, motion } = framerMontion;
  const [listValues, setListValues] = useState<IHoursManagementGrid[]>();
  const [oldListValues, setOldListValues] = useState<IHoursManagementGrid[]>();
  const [viewDoubleCard, setViewDoubleCard] = useState<IHoursManagementGrid[]>();
  const [totalBankHours, setTotalBankHours] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const [needSpinner, setNeedSpinner] = useState<boolean>(true);
  const [modalStatus, setModalStatus] = useState();

  const [doubleCard, setDoubleCard] = useState({ userId: 0, status: false });
  const history = useHistory();

  useEffect(() => {
    reqHoursManagement();
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 500);
  }, [listValues]);

  useEffect(() => {
    if (!doubleCard.status) return;
    let newArr: any[] = [];
    getProjectsByUser(newArr);
    setViewDoubleCard(newArr);
  }, [doubleCard]);

  async function reqHoursManagement() {
    const response: IResponseGetBankHours = await getHoursManagement(token);
    setListValues(response?.bankHours);
    setOldListValues(response?.bankHours);
    setTotalBankHours(response?.bankHoursTotal);
  }

  function getProjectsByUser(newArr: any[]): void {
    listValues?.forEach((item: IHoursManagementGrid) => {
      if (item?.userId !== doubleCard?.userId) return;
      item?.projects?.forEach((itemProject) => gerateObj(item, itemProject));
    });

    function gerateObj(item: IHoursManagementGrid, itemProject: IProject): void {
      const data = {
        ...item,
        projects: itemProject,
      };
      newArr.push(data);
    }
  }

  function handleSeeMoreClick(item) {
    const userIdQuery = `userId=${item?.userId}`;
    const projectIdQuery = `projectId=${item?.projects[0]?.id || item?.projects?.id}`;
    history.push(`/hours-management/${userIdQuery}&${projectIdQuery}`);
  }

  function handleFilterClick() {
    const filterProps = { rawData: oldListValues, value: filterValue, optionFilter: ["userName", "projects.name"] };
    const result = FilterData.start<IHoursManagementGrid>(filterProps);
    setListValues(result);
  }

  function handleClearFilterClick() {
    setListValues(oldListValues);
    setFilterValue("");
  }

  return (
    <>
      <ModalDebitHours
        modalStatus={modalStatus}
        setModalStatus={setModalStatus}
        setDoubleCard={setDoubleCard}
        reqHoursManagement={reqHoursManagement}
        doubleCard={doubleCard}
      />
      <div className="container-hours-management container">
        <Header total={totalBankHours} />
        <FilterRow
          doubleCard={doubleCard}
          setDoubleCard={setDoubleCard}
          filterValue={filterValue}
          setFilterValue={setFilterValue}
          handleClearFilterClick={handleClearFilterClick}
          handleFilterClick={handleFilterClick}
          list={listValues}
        />
        <Spinner status={needSpinner}>
          <AnimatePresence exitBeforeEnter>
            <motion.div
              key={doubleCard.userId}
              animate={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 100 }}
              exit={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.45 }}
            >
              <div className="flex gap20 flex-wrap center row box-row">
                {!doubleCard?.userId ? (
                  listValues?.length ? (
                    listValues?.map((item: IHoursManagementGrid) => {
                      return (
                        <Card
                          item={item}
                          setDoubleCard={setDoubleCard}
                          key={item?.userId}
                          ProjectsNameMuntipleCard={() => ProjectsNameMuntipleCard(item, true)}
                          ProjectHoursBalance={() => ProjectHoursBalance(item)}
                          setModalStatus={setModalStatus}
                          handleSeeMoreClick={handleSeeMoreClick}
                        />
                      );
                    })
                  ) : (
                    <h3 className="not-found-list-hours-management font-source-sans-pro bold center text-center color-text font-2rem ">
                      Não há registros para a busca realizada.
                    </h3>
                  )
                ) : (
                  viewDoubleCard?.map((item: IHoursManagementGrid, index: number) => {
                    if (item?.userId === doubleCard?.userId)
                      return (
                        <Card
                          item={item}
                          setDoubleCard={setDoubleCard}
                          key={item?.userId}
                          indexNumber={index}
                          ProjectsNameMuntipleCard={() => ProjectsNameMuntipleCard(item, false)}
                          ProjectHoursBalance={() => ProjectHoursBalance(item, true)}
                          setModalStatus={setModalStatus}
                          handleSeeMoreClick={handleSeeMoreClick}
                        />
                      );
                  })
                )}
              </div>
            </motion.div>
          </AnimatePresence>
        </Spinner>
      </div>
    </>
  );
}

interface IFilterRow {
  doubleCard: IDoubleCard;
  setDoubleCard: Dispatch<SetStateAction<IDoubleCard>>;
  filterValue: string;
  setFilterValue: Dispatch<SetStateAction<string>>;
  handleClearFilterClick: () => void;
  handleFilterClick: () => void;
  list: IHoursManagementGrid[];
}

interface IDoubleCard {
  userId: number;
  status: boolean;
}

function FilterRow({ doubleCard, setDoubleCard, filterValue, setFilterValue, handleClearFilterClick, handleFilterClick, list }: IFilterRow) {
  function getList() {
    const nameListProjectsNoRepeat = getNameProjects(list);
    const nameList = AutoCompleteList(list, "userName");
    return { nameListProjectsNoRepeat, nameList };
  }

  function getNameProjects(list: IHoursManagementGrid[]) {
    const nameProjects = list?.map((item) => item?.projects?.map((project) => project?.name));
    if (!nameProjects) return [];
    let nameListProjects = [];
    for (let names of nameProjects) {
      names?.map((name) => nameListProjects.push(name));
    }
    return [...new Set(nameListProjects)];
  }

  return (
    <>
      <datalist id="datalist">
        {getList()?.nameListProjectsNoRepeat?.map((item) => (
          <option label="Projeto">{item}</option>
        ))}
        {getList()?.nameList?.map((item) => (
          <option label="Profissional"> {item}</option>
        ))}
      </datalist>
      <div className="header-filter-menu rowFilterContainer">
        {doubleCard?.status ? (
          <div className="box-back-hours-management center align-end width-100 box-row">
            <BackCards setMultipleCard={setDoubleCard} />
          </div>
        ) : (
          <>
            <Input
              className="Input-filter-hours-management"
              name="filterValue"
              placeholder="Profissional ou Projeto"
              label="Filtrar"
              list="datalist"
              value={filterValue}
              setValue={(e) => {
                setFilterValue(e.target.value);
              }}
            />
            <div className="btn-filter-hours-management box-row">
              <button className={`btn bg-primary`} type="button" onClick={handleFilterClick}>
                FILTRAR
              </button>
              <button className={`btn bg-secondary`} type="button" onClick={handleClearFilterClick}>
                LIMPAR
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
